export class VlcUtils {

    // Función para generar el enlace para VLC
    static buildVlcLinks = (src, type) => {
        if (!src) return null;

        // Asegura URL absoluta con http/https
        const hasProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(src);
        const absolute = hasProtocol ? src : `http://${src}`;


        // Android usa intent:// con el paquete de VLC
        const hostAndPath = absolute.replace(/^https?:\/\//i, "");
        const scheme = absolute.startsWith("https") ? "https" : "http";

        let android;
        let ios;
        if (!type) {
            ios = `vlc-x-callback://x-callback-url/stream?url=${encodeURIComponent(absolute)}`;
            android =
                `intent://${hostAndPath}` +
                `#Intent;scheme=${scheme};package=org.videolan.vlc;end`;
        } else if (type === 'video') {
            ios = `vlc-x-callback://x-callback-url/stream?url=${encodeURIComponent(absolute)}`;
            android = `intent://${hostAndPath}#Intent;package=org.videolan.vlc;scheme=${scheme};type=video/*;end`;
        }
        console.log(android);

        // Desktop suele aceptar vlc:// + URL completa SIN tocarla
        const desktop = `${absolute}`; // <- Ojo: NO pasar por new URL()

        return {ios, android, desktop};
    };

    // Función para abrir en VLC
    static openInVlc = (e, src, type) => {
        e.preventDefault();
        e.stopPropagation();

        const links = this.buildVlcLinks(src, type);

        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isAndroid = /Android/i.test(ua);
        const isIOS = /iPhone|iPad|iPod/i.test(ua);
        const isDesktop = !isAndroid && !isIOS;

        const href = isIOS ? links.ios : isAndroid ? links.android : links.desktop;

        if (isDesktop) {
            // Intentar copiar al portapapeles
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(href).then(() => {
                    alert("Enlace copiado al portapapeles. Abrelo manualmente en VLC.");
                });
            }

            return;
        }

        // Intentar abrir el enlace
        window.open(href, '_blank');
    };
}
